import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import MaterialTable from '@material-table/core'
import EmptyPOS from './EmptyPOS'
import { withTranslation } from 'react-i18next'
// import TableActionBtn from 'components/TableActionBtn'
// import Icons from 'includes/Icons'
// import { useDispatch } from 'react-redux'
// import { previewModal } from 'store/slices/miscSlice'
// import Propmt from 'components/Propmt'
// import { showModal } from 'store/slices/miscSlice'
// import AddPOS from './AddPOS'
// import { POSValidation } from '../validation'
import { Typography } from '@mui/material'


export default withTranslation()(function POSTable({ t }) {
  // const { data: pos } = useSWR('pos?page=1&page-size=10')
  const { data: pos } = useSWR('pos')

  const [Pos, setPos] = useState([])
  useEffect(() => {
    if (pos) setPos(pos?.data.data.reverse())
  }, [pos])
  // const dispatch = useDispatch()

  // const ActiveMsg = ({ id, status }) => <Propmt
  //   msg={status === 'suspended' ? t('pos.form.activate.prompt') : t('pos.form.ban.prompt')}
  //   successMsg={status === 'suspended' ? t('pos.form.activate.successMsg') : t('pos.form.ban.successMsg')}
  //   url={`pos/${id}/${status === 'suspended' ? 'mark-as-active' : 'mark-as-blocked'}`}
  //   btnText={status === 'suspended' ? t('pos.form.activate.text') : t('pos.form.ban.text')}
  // />
  const cellStyles = {
    fontWeight: '400',
    fontSize: '16px',
    color: '#657585',
    lineHeight: '24px'
  }
  
  return (
    <>
      {
        !pos?.data ? (
          <EmptyPOS data={pos?.data} />
        ) : (
          <div className="bg-white p-5 rounded-md overflow-hidden">
            <MaterialTable
              columns={[
                { title: t('pos.form.name.label'), field: 'name', render: (data) => <Typography sx={{ ...cellStyles }}>{data.name}</Typography> },
                { title: t('pos.id'), field: 'code', render: (data) => <Typography sx={{ ...cellStyles }}>{data.code}</Typography> },
                { title: t('pos.name'), field: 'name', render: (data) => <Typography sx={{ ...cellStyles }}>{data.name}</Typography> },
                { title: t('pos.user'), field: 'user', render: (data) => <Typography sx={{ ...cellStyles }}>{data.user}</Typography> },
                {
                  title: t('misc.status'),
                  field: 'status',
                  render: ({ status }) => <>
                    {
                      status === 'active' ? (
                        <span className="p-1 px-2 bg-primary bg-opacity-30 rounded-md text-primary w-[100px] block text-center" style={{ textTransform: 'Capitalize' }}>{status}</span>
                      ) : (
                        <span className="p-1 px-2 bg-failure bg-opacity-30 rounded-md text-failure w-[100px] block text-center" style={{ textTransform: 'Capitalize' }}>{status}</span>
                      )
                    }
                  </>
                }
              ]}
              // actions={[
              //   {
              //     icon: ''
              //   }
              // ]}
              options={{
                actionsColumnIndex: -1,
                headerStyle: {
                  fontSize: '14px', fontWeight: '700', fontFamily: 'Helvetica Neue', lineHeight: '21px', color: '#657585'
                }
              }}
              localization={{
                header: {
                  actions: ''
                }
              }}
              data={Pos ?? []}
              // icons={Icons}
              components={{
                Toolbar: () => (
                  <div className="w-full lg:flex justify-between p-3">
                    <h3 className="text-2xl font-semibold text-placeholder mb-5 lg:mb-0">{t('pos.pos')}</h3>
                  </div>
                ),
                // Action: ({ data }) => (
                //   <>
                //     <TableActionBtn
                //       data={[
                //         {
                //           Content: {
                //             // icon: UIcons.UilCodeBranch,
                //             text: t('pos.form.edit.text')
                //           },
                //           action: () => dispatch(showModal({
                //             title: t('pos.edit'),
                //             content: AddPOS,
                //             url: `pos/${data.id}`,
                //             method: 'put',
                //             formClass: 'w-11/12 md:w-[390px]',
                //             validation: POSValidation,
                //             values: {
                //               name: data.name,
                //               branch_id: data.branch_id
                //             }
                //           }))
                //         },
                //         {
                //           Content: {
                //             text: data.status === 'suspended' ? t('pos.form.activate.text') : t('pos.form.ban.text'),
                //             classList: data.status === 'suspended' ? 'text-green' : 'text-failure'
                //           },
                //           action: () => {
                //             dispatch(previewModal({
                //               title: data.status === 'suspended' ? `${t('pos.form.activate.text')} ${t('pos.pos')}` : `${t('pos.form.ban.text')} ${t('pos.pos')}`,
                //               content: () => <ActiveMsg id={data.id} status={data.status} />
                //             }))
                //           }
                //         },
                //       ]}
                //     />
                //   </>
                // )
              }}
            />
          </div>
        )
      }
    </>
  )
})
